var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Bold",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,11.555V9.994a9,9,0,0,0-18,0v1.561a5.307,5.307,0,0,0-3,4.763v.364A5.324,5.324,0,0,0,5.318,22H5.5A2.5,2.5,0,0,0,8,19.5v-6a2.5,2.5,0,0,0-2-2.449V9.994a6,6,0,0,1,12,0v1.057A2.5,2.5,0,0,0,16,13.5v6A2.5,2.5,0,0,0,18.5,22h.182A5.324,5.324,0,0,0,24,16.682v-.364A5.307,5.307,0,0,0,21,11.555ZM5,18.978a2.321,2.321,0,0,1-2-2.3v-.364a2.321,2.321,0,0,1,2-2.3Zm16-2.3a2.321,2.321,0,0,1-2,2.3V14.022a2.321,2.321,0,0,1,2,2.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.09185b90aac6b0b532c36e64319b451a.svg";
export { ForwardRef as ReactComponent };